// gql.ts
import { gql } from '@apollo/client';

export const CREATE_OFFER = gql`
  mutation CreateOffer($callId: String!, $offer: JSON!, $productId: String!, $sessionId: String!) {
    createOffer(callId: $callId, offer: $offer, productId: $productId, sessionId: $sessionId)
  }
`;

export const ADD_ICE_CANDIDATE = gql`
  mutation AddIceCandidate($callId: String!, $candidate: JSON!, $sessionId: String!) {
    addIceCandidate(callId: $callId, candidate: $candidate, sessionId: $sessionId)
  }
`;

export const ON_ANSWER = gql`
  subscription OnAnswer($sessionId: String!) {
    onAnswer(sessionId: $sessionId)
  }
`;

export const ON_ICE_CANDIDATE = gql`
  subscription OnIceCandidate($sessionId: String!) {
    onIceCandidate(sessionId: $sessionId)
  }
`;

export const ON_CALL_READY = gql`
  subscription OnCallReady($sessionId: String!) {
    onCallReady(sessionId: $sessionId)
  }
`;

export const ON_CALL_STATUS_CHANGE = gql`
  subscription OnCallStatusChange($sessionId: String!) {
    onCallStatusChange(sessionId: $sessionId)
  }
`;
